import React from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom"
import { ToastContainer } from 'react-toastify'
import Header from './header'
import Login from '../account/Login/index.jsx'

import PrivateRoute from './privateRoute'

/* Client */
import ClientList from '../clients/list.jsx'
import ClientNew from '../clients/new.jsx'
import ClientEdit from '../clients/edit.jsx'
import ClientView from '../clients/view.jsx'
import ClientCampaignNew from '../clients/campaigns/new.jsx'
import ClientCampaignEdit from '../clients/campaigns/edit.jsx'
import ClientDevicesNew from '../clients/devices/new.jsx'
import ClientDevicesView from '../clients/devices/view.jsx'
import ClientDevicesEdit from '../clients/devices/edit.jsx'

/* Devices */
import DeviceList from '../devices/list.jsx'
import DeviceView from '../devices/view.jsx'
import DeviceEdit from '../devices/edit.jsx'

/* Campaigns */
import CampaignsList from '../campaigns/list.jsx'
import CampaignsEdit from '../campaigns/edit.jsx'

/* Playlists */
import PlaylistList from '../playlists/list.jsx'
import PlaylistNew from '../playlists/new.jsx'
import PlaylistView from '../playlists/view.jsx'
import PlaylistEdit from '../playlists/edit.jsx'
import PlaylistCampaignsList from '../playlists/campaignsList.jsx'
import CollectionList from '../playlists/collectionList.jsx'
import CollectionView from '../playlists/collectionView.jsx'
import CollectionNew from '../playlists/collectionNew.jsx'
import CollectionEdit from '../playlists/collectionEdit.jsx'
import CollectionCampaignsList from '../playlists/collectionsCampaignsList.jsx'
import ResetPasswordRequest from '../account/ResetPassword/index.jsx'
import ResetPassword from '../account/ResetPassword/ResetPassword.jsx'

/* Users */
import UsersList from '../users/list.jsx'
import UserNew from '../users/new.jsx'
import UserEdit from '../users/edit.jsx'
import UserRolesList from '../users/userRoleList.jsx'
import UserRoleEdit from '../users/userRoleEdit.jsx'

/* Affiliates */
import AffiliatesList from '../affiliates/list.jsx'
import AffiliateNew from '../affiliates/new.jsx';
import AffiliateEdit from '../affiliates/edit.jsx'

/* Account */
import MyAccount from '../account/MyAccount.jsx';
import ChangePassword from '../account/ChangePassword.jsx';

function Layout() {
	return (
		<Router>
			<Header />
			<main id="main">
				<ToastContainer position="top-right" />
				<Switch>
					<Route exact path="/login" component={Login} />
					<Route exact path="/reset" component={ResetPasswordRequest} />
					<Route exact path="/reset-password" component={ResetPassword} />
					<PrivateRoute exact path="/clients" component={ClientList} />
					<PrivateRoute exact path="/clients/new" component={ClientNew} />
					<PrivateRoute exact path="/clients/:clientId/edit" component={ClientEdit} />

					<PrivateRoute exact path="/clients/:clientId/campaigns" component={ClientView} />
					<PrivateRoute exact path="/clients/:clientId/campaigns/new" component={ClientCampaignNew} />
					<PrivateRoute exact path="/clients/:clientId/campaigns/:campaignId" component={ClientCampaignEdit} />

					<PrivateRoute exact path="/clients/:clientId/devices" component={ClientView} />
					<PrivateRoute exact path="/clients/:clientId/devices/new" component={ClientDevicesNew} />
					<PrivateRoute exact path="/clients/:clientId/devices/:deviceId" component={ClientDevicesView} />
					<PrivateRoute exact path="/clients/:clientId/devices/:deviceId/edit" component={ClientDevicesEdit} />

					<PrivateRoute exact path="/clients/:clientId/playlists/:playlistId" component={PlaylistView} />
					<PrivateRoute exact path="/clients/:clientId/playlists/:playlistId/campaigns" component={PlaylistCampaignsList} />

					<PrivateRoute exact path="/clients/:clientId/collections/:collectionId" component={CollectionView} />
					<PrivateRoute exact path="/clients/:clientId/collections/:collectionId/campaigns" component={CollectionCampaignsList} />

					<PrivateRoute exact path="/clients/:clientId/playlists" component={ClientView} />
					<PrivateRoute exact path="/clients/:clientId/collections" component={ClientView} />

					<PrivateRoute exact path="/devices" component={DeviceList} />
					<PrivateRoute exact path="/devices/:deviceId" component={DeviceView} />
					<PrivateRoute exact path="/devices/:deviceId/edit" component={DeviceEdit} />

					<PrivateRoute exact path="/campaigns" component={CampaignsList} />
					<PrivateRoute exact path="/campaigns/:campaignId" component={CampaignsEdit} />

					<PrivateRoute exact path="/assets/playlists" component={PlaylistList} />
					<PrivateRoute exact path="/assets/playlists/new" component={PlaylistNew} />
					<PrivateRoute exact path="/assets/playlists/:playlistId" component={PlaylistView} />
					<PrivateRoute exact path="/assets/playlists/:playlistId/edit" component={PlaylistEdit} />
					<PrivateRoute exact path="/assets/playlists/:playlistId/campaigns" component={PlaylistCampaignsList}/>

					<PrivateRoute exact path="/assets/collections" component={CollectionList} />
					<PrivateRoute exact path="/assets/collections/new" component={CollectionNew} />
					<PrivateRoute exact path="/assets/collections/:collectionId" component={CollectionView} />
					<PrivateRoute exact path="/assets/collections/:collectionId/edit" component={CollectionEdit} />
					<PrivateRoute exact path="/assets/collections/:collectionId/campaigns" component={CollectionCampaignsList}/>

					<PrivateRoute exact path="/users/list" component={UsersList} />
					<PrivateRoute exact path="/users/new" component={UserNew} />
					<PrivateRoute exact path="/users/:userId/edit" component={UserEdit} />
					<PrivateRoute exact path="/users/roles" component={UserRolesList} />
					<PrivateRoute exact path="/users/roles/:roleId/edit" component={UserRoleEdit} />

					<PrivateRoute exact path="/affiliates" component={AffiliatesList} />
					<PrivateRoute exact path="/affiliates/new" component={AffiliateNew} />
					<PrivateRoute exact path="/affiliates/:affiliateId/edit" component={AffiliateEdit} />

					<PrivateRoute exact path="/account" component={MyAccount}/>
					<PrivateRoute exact path="/account/change-password" component={ChangePassword} />

					<Route
						exact
						path="/assets"
						render={() => {
							return (
								<Redirect to="/assets/playlists" />
							)
						}}
					/>

					<Route
						exact
						path="/"
						render={() => {
							return (
								<Redirect to="/clients" />
							)
						}}
					/>
				</Switch>
			</main>
		</Router>
	)
}

export default Layout
